import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import { useStyles } from './styles';

export default function TermsConditionList (props) {

    const classes = useStyles();

    return (
        <List
            component="nav"
            aria-lablledby="nested-list"
            className="terms-condition-list-cover"
        >
            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    <span>A.</span>
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="LOAN" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The principal amount of the loan (“Principal Amount”) shall be as confirmed by The Bank to the Borrower"
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Charges (including service & transaction fees) shall be applicable to the loan and these will be added to the loan advance and paid along with the loan granted the Borrower."
                    />
                </ListItem>
            </List>

            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    B.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="INTEREST RATE" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Service fee on the loan shall be charged at the prevailing rate as stated under the loan section of the form."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank may at its sole discretion change the prevailing interest rate for any reason and any such change shall be binding on the Borrower. Any change shall become applicable following a minimum of three (3) days written notice."
                    />
                </ListItem>
            </List>

            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    C.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="REPAYMENT" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="All payments due by the Borrower shall be deducted from Borrower’s wallet & paid by the Business Partner into Mkobo’s wallet." />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="In Particular:" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Repayment shall be in accordance with loan Schedule."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Weekly loan repayments will be debited from Borrower’s wallet on each Repayment due date as detailedin the Schedule."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank may send SMS notification before each Repayment Date and the Borrower hereby agrees that such notice shall be conclusively deemed received by the Borrower without need of any further notice."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower hereby agrees that non-payment of the amount owed by any Repayment Date shall render the Borrower in default and entitle the Bank to immediately take steps to recover the outstanding loan amount in accordance with clause F below."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        V.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower may make an early payment of the total outstanding loan obligation due hereunder at any time by a direct deposit to the Bank’s wallet. Early repayment will render the total principal and accrued service fees payable."
                    />
                </ListItem>
            </List>


            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    D.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="USE OF CREDIT BUREAU" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank will approach a dedicated Credit Reference Agency for a credit report on the applicant."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower authorizes the Bank to access any information available to it as provided by the Credit Agency."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower also agrees that their details and the approved loan disbursed will be registered with the Credit Agency."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="n the event the Borrower wishes to access the credit report, the Bank will advise the Borrower of the contact details of the relevant credit agency and the Borrower waives any claims he/ she may have against the Bank in respect of such disclosure."
                    />
                </ListItem>
            </List>


            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    E.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="INFORMATION FROM NETWORK MANAGER" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" 
                    primary="The Borrower hereby consents to the Bank requesting and the Network Manager/Business Partner providing, relevant transaction information to the Bank as required by the Bank in the processing of the application."
                />
            </ListItem>
            

            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    F.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="DEFAULT" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="Default in terms of this Agreement will occur if:" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Repayment in full of the outstanding amount or interest, is not made on or before the agreed Repayment Date."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Any information, representation, warranty or assurance made or given by the Borrower in connection with the application for this loan or any information or documentation supplied by the Borrower, is later discovered to be misleading or materially incorrect; or"
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower in any way perpetrates or attempts to or is involved in any act of fraud or other criminal activity in respect of the Bank or the Loan or does or omits to do anything, which may prejudice the Bank’s rights, terms of this Agreement or cause the Bank to suffer any loss or damage."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Any other action by the Borrower oroccurrence of an event categorized as default or an event of default in the Offer Letter."
                    />
                </ListItem>
            </List>



            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    G.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="If  a  Default  occurs  as  indicated  above,  all  amounts  outstanding  under  the  loan  facility  shall immediately  become  due  and  payable  to  the  Bank  and  the  Bank  shall  be  entitled  to  do  the following." />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Trigger its ‘Right of Loan Set-Off’ Clause and write CBN to exercise its regulatory power  and  extend  its  right to loan  repayment to other  funds  of  the  Borrower  held  by any bank in the country."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="If (i) in the case of paragraph I above, the Bank has not received on a Repayment Date the amount payable by the relevant date in accordance with the Repayment Schedule, or  (ii)  in  the  case  of  paragraphs  II -IV,  a  TOD  (Temporary  Overdraft)  covering  the value  of  Principal  +  Service  +  Transaction  fees  shall  immediately  be  placed  on Borrower’s wallet."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Where  more  than  forty-eight  (48)  hours  have  elapsed  since  the  Repayment Date or delivery of the demand notice as indicated in paragraph VI, and the Repayment Amount or any portion ofit remains outstanding, MKOBO shall apply  the  percentage  of  the  loan  represented  by  the  service  fee  at  the prevailing  rate,  as  default  weekly  interest  on  any  such  unpaid  amount  for every week the same remains outstanding."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="If the loan remains outstanding after half of its cycle lapses, the bank reserves the  right  to  seek  repayment  via  the  Borrower’s  debit  card  which  was tokenized."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        V.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="Following the Borrower’s default, the Bank reserves the right to assign it’s right, title and interest under the agreement to anexternal collections agency who will take all steps, within the bounds of the law, to collect the outstanding loan amount."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        VI.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank also reserves the right to commence legal proceedings against the defaulting Borrower and is under no obligation to inform the Borrower before such proceedings commence."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        VII.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Borrower shall reimburse the Bank for all costs and expenses (including legal  cost)  incurred  by  the  Bank  in  connection  with  or  incidental  to  the recovery  of  the  loan.  Interest  on  any  amount,  which  becomes due  and payable, shall be charged in accordance with these Terms and Conditions."
                    />
                </ListItem>
            </List>





            {/* next column */}
            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    H.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="RIGHT OF LOAN SET-OFF" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="By signing this offer letter/loan agreement and by drawing on the loan, I covenant to repay the loan as and when due. In the event that I fail to repay the loan as agreed and the  loan  becomes  delinquent,  the  bank  shall  have  the  right  to  report  the  delinquent loan  to  the  CBN  through  the  Credit  Risk  Management  System  (CRMS)  or  by  any other means and request the CBN exercise its regulatory power to direct all banks and other  financial  institutions  under  its  regulatory  purview  to  set-off  my  indebtedness from  any  money  standing  to  my  credit  in  any  bank  account  and  from  any  other financial assets they may be holding for my benefit." />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="I covenant and warrant  that  the  bank  shall  have  power  to  set  off  my  indebtedness under   this   loan   agreement   from   all   such   monies   and   funds   standing   to   my credit/benefit in any and all such accounts or from any other financial assets belonging to me and in the custody of any such bank." />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="  hereby  waive  any  right  of  confidentiality  whether  arising  under  common  law  or statue or in any other manner whatsoever and irrevocably agree that I shall not argue to the contrary before any court of law, tribunal, administrative authority or any other body acting in any judicial or quasi-judicial capacity." />
            </ListItem>



            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    I.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="COMMUNICATION" />
            </ListItem>
            <ListItem className="list-item-cover">
                <ListItemText className="list-item-text-cover-subitem" primary="The Borrower agrees that the Bank may communicate with them by sending notices, messages, alerts and statements in relation to this Agreement in the following manner:" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="To the most recent address the Bank holds for the Borrower on file."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="By delivery to any email address provided during the application process."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="By delivery of an SMS to any mobile telephone number the Borrower has provided to the Bank."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="By delivery to the office address the Bank holds for the Borrower."
                    />
                </ListItem>
            </List>


            <ListItem className="list-item-cover">
                <ListItemIcon className="list-item-icon-cover">
                    J.
                </ListItemIcon>
                <ListItemText className="list-item-text-cover" primary="MISCELLANEOUS" />
            </ListItem>
            <List
                component="div"
                disablePadding
                className="terms-condition-nested-list-cover"
            >
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        I.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="This Agreement and any disputes arising out of or in connection with the same shall be governed by the laws of the Federal Republic of Nigeria and shall be subject to the jurisdiction of the courts inLagos, Nigeria."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        II.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="If the Bank shall have reasonably determined that the introduction of, or a change in any applicable law or regulation or in the interpretation by any governmental or other regulatory authority charged with the administration or court of competent jurisdiction makes it apparent thatit is unlawful, illegal or not feasible for the Bank or the Borrower to give effect to fund, or maintain or perform their obligations as contemplated under this Agreement the Bank shall immediately give notice of such occurrence to the Borrower and the commitment hereunder shall immediately be cancelled or discharged and the Borrower shall on the next succeeding Repayment Date or such earlier dates as may be required repay to the Bank the amount outstanding together with accrued interest thereon and any amounts due to the Bank under this Agreement."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        III.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="If the Bank does not strictly enforce its rights under this Agreement (including its right to insist on the repayment of all sums due on the Repayment Date) or grant the Borrower an indulgence, the Bank will not be prevented from insisting upon its strict rights at a later date."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        IV.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank reserves the right to transfer or assign its rights and obligation under this Agreement (including its obligation to lend money to the Borrower or the amount owned under this Agreement to another person."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        V.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="The Bank may inform the Borrower of a transfer/assignment of its rights hereunder if such a transfer results in a change in the administration of this Agreement."
                    />
                </ListItem>
                <ListItem className={`${classes.listNested} nested-list-item-cover`}>
                    <ListItemIcon className="list-item-icon-cover">
                        VI.
                    </ListItemIcon>
                    <ListItemText className="list-item-text-cover" 
                        primary="All the terms and conditions stated in this loan application have been read and understood by me and I hereby accept the terms and conditions."
                    />
                </ListItem>
            </List>
        </List>
    )
}